import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Content from '../views/Content.vue'
import Community from '../views/Community.vue'
import CommunityList from '../views/CommunityList.vue'
import Message from '../views/Message.vue'
import Publish from '../views/Publish.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Admin from '../views/Admin.vue'
import UserCenter from '../views/UserCenter.vue'
import OtherUserCenter from '../views/OtherUserCenter.vue'
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/post/:id',
    name: 'Content',
    component: Content
  },
  {
    path: '/community',
    name: 'CommunityList',
    component: CommunityList
  },
  {
    path: '/community/:id',
    name: 'Community',
    component: Community
  },
  {
    path: '/message',
    name: 'Message',
    component: Message
  },
  {
    path: '/publish',
    name: 'Publish',
    component: Publish,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/login',
    name: "Login",
    component: Login
  },
  {
    path: '/signup',
    name: "SignUp",
    component: SignUp
  },{
    path: '/admin',
    name: "Admin",
    component: Admin
  },{
    path: '/usercenter',
    name: "UserCenter",
    component: UserCenter,
    meta: {
      requireAuth: true
    }
  },{
    path: '/user/:userId',
    name: "OtherUserCenter",
    component: OtherUserCenter
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/admin') {
    const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
    if (!loginResult.userLevelCode || loginResult.userLevelCode < 20) {
      next({ name: 'Home' });
      return;
    }
  }
  next();
});

export default router